import { DocumentDownloadButtonComponent } from '../../../components/document-download-button/document-download-button.component';
import { FileInputComponent } from '../../../components/file-input/file-input.component';
import { lastValueFrom, merge } from 'rxjs';
import { getDownloadURL } from 'firebase/storage';
import { Component, OnInit, ViewChild, ElementRef, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { FormGroup, FormsModule } from '@angular/forms';

import { AppDataService } from 'src/app/services/data/app-data.service';
import { PipedriveService } from '../../../services/pipedrive.service';
import { AclService } from '../../../services/acl.service';

import { format, getMonth, getYear } from 'date-fns';
import { EnquiryService } from 'src/app/services/enquiry/enquiry.service';
import { EnumAcmiType, IEnquiry } from '@simplyfly/shared';
import {
  getDisplayedEnquiryRefTitle,
  getEnquiryBreadcrumbTitle,
  getEnquiryRefTitle,
  getEnquiryRefTitleWithoutPrefix,
  shouldUseEnquiryReferenceForContract
} from 'src/app/interfaces/enquiry.helpers';
import { Subscription } from 'rxjs';
import { IEnquiryOffer } from '@simplyfly/shared';
import { getAirlineIdFromOffer } from 'src/app/interfaces/enquiry-offer.helpers';
import { EnumEnquiryOfferStatus } from '@simplyfly/shared';
import { EnumEnquiryType } from '@simplyfly/shared';
import { getEnumEnquiryPrefix, getEnumEnquiryTypeLabel } from 'src/app/enums/enquiry-type.helpers';
import { EnumEnquiryStatus } from '@simplyfly/shared';
import { getEnquiryStatusColor, getEnumEnquiryStatusLabel } from 'src/app/enums/enquiry-status.helpers';
import { EnquiryOfferService } from 'src/app/services/enquiry-offer/enquiry-offer.service';
import { EnquiryCotationService } from 'src/app/services/enquiry-cotation/enquiry-cotation.service';
import { IEnquiryCotation } from '@simplyfly/shared';
import { getAirlineIdFromCotation } from 'src/app/interfaces/enquiry-cotation.helpers';
import { EnumEnquiryCotationStatus } from '@simplyfly/shared';
import { getEnumEnquiryCotationStatusLabel } from 'src/app/enums/enquiry-cotation-status.helpers';
import { EnumCurrency } from '@simplyfly/shared';
import { getDefaultCurrency, getEnumCurrencyLabel, getEnumCurrencySymbol } from 'src/app/enums/currency.helpers';
import { EnumEnquiryCancelledReason } from '@simplyfly/shared';
import { getEnumEnquiryCancelledReasonLabel } from 'src/app/enums/enquiry-cancelled-reason.helpers';
import { IInvoice } from '@simplyfly/shared';
import {
  getInvoiceTitle,
  invoiceDiffDueDate,
  invoiceGetAmountSoldeLeft,
  invoiceGetAmountSoldePaid
} from 'src/app/interfaces/invoice.helpers';
import { InvoiceService } from 'src/app/services/invoices/invoices.service';
import { IQuotation } from '@simplyfly/shared';
import { getQuotationStatusLabel } from 'src/app/interfaces/quotation.helpers';
import { QuotationService } from 'src/app/services/quotations/quotations.service';
import { getLanguageLabel } from 'src/app/enums/language.helpers';
import { EnumInvoiceType } from '@simplyfly/shared';
import { getEnumInvoiceTypeLabel } from 'src/app/enums/invoice-type.helpers';
import { EnumAcl } from '@simplyfly/shared';
import { IUser } from '@simplyfly/shared';
import { getUserFullname } from 'src/app/interfaces/user.helpers';
import { IFlightBrief } from '@simplyfly/shared';
import { FlightBriefService } from 'src/app/services/flight-briefs/flight-briefs.service';
import {
  faArrowRightArrowLeft,
  faArrowDown,
  faArrowUp,
  faCheck,
  faCopy,
  faEdit,
  faExternalLink,
  faPlus,
  faTrash,
  faWarning
} from '@fortawesome/free-solid-svg-icons';
import { IAirline } from '@simplyfly/shared';
import { IPipedriveOrganization, IPipedrivePerson } from '@simplyfly/shared';
import { getCountryLabel } from 'src/app/enums/continent-code.helpers';
import { IAircraftCompiled } from '@simplyfly/shared';
import { IAircraftModel } from '@simplyfly/shared';
import { IAirport } from '@simplyfly/shared';
import { IBankAccount } from '@simplyfly/shared';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { IEnquiryFlight } from '@simplyfly/shared';
import { EnquiryFlightService } from 'src/app/services/enquiry-flights/enquiry-flights.service';
import { BreadcrumbsService } from 'src/app/services/breadcrumbs/breadcrumbs.service';
import { UserService } from 'src/app/services/user/user.service';
import { IFile } from '@simplyfly/shared';
import { generateRandomId, formatBytes } from 'src/app/misc.utils';
import { IEnquiryDocument } from '@simplyfly/shared';
import { EnquiryDocumentService } from 'src/app/services/enquiry-documents/enquiry-documents.service';
import {
  AlertService,
  EnumAlertOptionFlexAlign,
  EnumAlertOptionSize
} from 'src/app/services/alert/alert.service';
import {
  EnquiryConfirmedModalComponent,
  IConfirmedCotationsPayload
} from './enquiry-confirmed-modal/enquiry-confirmed-modal.component';
import { EnquiryCancelledModalComponent } from './enquiry-cancelled-modal/enquiry-cancelled-modal.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AircraftModelService } from 'src/app/services/aircraft-models/aircraft-models.service';
import { AircraftCompiledService } from 'src/app/services/aircraft-compiled/aircraft-compiled.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { EnquiryFlightsCardsComponent } from '../../../components/enquiry-flights-cards/enquiry-flights-cards.component';
import { EnquiryCotationsComponent } from '../../../components/enquiry-cotations/enquiry-cotations.component';
import { QuotationsListForEnquiryComponent } from '../../../components/quotations-list-for-enquiry/quotations-list-for-enquiry.component';
import { InvoicesListForEnquiryComponent } from '../../../components/invoices-list-for-enquiry/invoices-list-for-enquiry.component';
import { FlightBriefsListForEnquiryComponent } from '../../../components/flight-briefs-list-for-enquiry/flight-briefs-list-for-enquiry.component';
import { DatePipe } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

interface CotationLine {
  enquiryId: string;
  offerId: string;
  cotationId: string;
  status: EnumEnquiryCotationStatus | EnumEnquiryOfferStatus;
  statusTitle: string;
  followedUp: boolean;
  airlineId: string;
  airlineTitle: string;
  airlineCountryCode: string;
  airlineCountryTitle: string;
  itineraryId: string;
  itineraryTitle: string;
  legsId: string[];
  isNationalFlight: boolean;
  legsAirportsCode: string[];
  legsTitle: string;
  aircraftCompiledId: string;
  aircraftCompiledModel: string;
  aircraftTitle: string;
  ageAverage: number;
  aircraftErrorMessages: string[];
  capacityAircraft: number;
  weightAircraft: number;
  volumeAircraft: number;
  nbPax: number;
  currency: string;
  buyingPrice: number;
  buyingPriceInCurrency: number;
  taxesTotalPax: number;
  taxesTotalPaxInCurrency: number;
  catering: number;
  cateringInCurrency: number;
  priceNetTTC: number;
  priceNetTTCInCurrency: number;
  pricePP: number;
  pricePPInCurrency: number;
  sellingPrice: number;
  sellingPriceInCurrency: number;
  margin: number;
  marginInCurrency: number;
  marginPercent: number;
  marginPercentInCurrency: number;
  marginOnConfirmed: number | null;
  sellingPricePP: number;
  sellingPricePPInCurrency: number;
  notes: string;
  acmiAircraftType?: string;
  acmiAircraftVersion?: string;
  acmiDateStart?: Date;
  acmiDateEnd?: Date;
  acmiBhMinimumPerMonth?: number;
  acmiMinimumCycleRatio?: string;
  acmiBhRate?: number;
  acmiBase?: string;
  acmiRouting?: string[];
  acmiNbCrew?: number;
  acmiPerDiemsIncluded?: boolean;
  acmiPerDiems?: string;
  acmiCrewHotacIncluded?: boolean;
  acmiCrewHotac?: string;
  acmiHasAdditionalInsurance?: boolean;
  acmiAdditionalInsurance?: string;
  acmiVolumeMax?: number;
  acmiWeightMax?: number;
}

@Component({
    selector: 'app-enquiry-view',
    templateUrl: './enquiry-view.component.html',
    styleUrls: ['./enquiry-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DocumentDownloadButtonComponent, FileInputComponent,
      RouterLink,
      FaIconComponent,
      EnquiryFlightsCardsComponent,
      EnquiryCotationsComponent,
      QuotationsListForEnquiryComponent,
      InvoicesListForEnquiryComponent,
      FlightBriefsListForEnquiryComponent,
      FormsModule,
      EnquiryConfirmedModalComponent,
      EnquiryCancelledModalComponent,
      DatePipe,
      TranslateModule
    ]
})
export class EnquiryViewComponent implements OnInit, OnDestroy {

  constructor(
    private aircraftCompiledService: AircraftCompiledService,
    private aircraftModelService: AircraftModelService,
    private authService: AuthService,
    private appDataService: AppDataService,
    private pipedriveService: PipedriveService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private aclService: AclService,
    private enquiryService: EnquiryService,
    private enquiryOfferService: EnquiryOfferService,
    private enquiryCotationService: EnquiryCotationService,
    private invoiceService: InvoiceService,
    private quotationService: QuotationService,
    private flightBriefService: FlightBriefService,
    private loaderService: LoaderService,
    private enquiryFlightService: EnquiryFlightService,
    private enquiryDocumentService: EnquiryDocumentService,
    private breadcrumbsService: BreadcrumbsService,
    private userService: UserService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.subscriptions.add(merge(
      this.translateService.onLangChange,
      this.translateService.onDefaultLangChange,
      this.translateService.onTranslationChange
    ).subscribe(() => this.changeDetectorRef.markForCheck()));
    this.authService.isLoggedObservable.subscribe(
      (isLogged: boolean) => (this.isLogged = isLogged)
    );
    this.authService.userObservable.subscribe((user: IUser) => {
      this.user = user;
      this.checkUserCanAccessEnquiryType();
    });

    this.aircraftModelService.aircraftModelsObservable.subscribe((aircraftModels: IAircraftModel[]) => {
      if (aircraftModels) {
        for (const aircraftModel of aircraftModels) {
          this.aircraftModelsObj[aircraftModel.id] = aircraftModel;
        }
      }
    });
  }
  @ViewChild('enquiryConfirmedModal', { static: false })
  enquiryConfirmedModalComponent: EnquiryConfirmedModalComponent;
  @ViewChild('enquiryCancelledModal', { static: false })
  enquiryCancelledModalComponent: EnquiryCancelledModalComponent;
  @ViewChild('enquiryDocumentFileInput', { static: false })
  enquiryDocumentFileInputElement: FileInputComponent;
  @ViewChild('enquiryDocumentModal', { static: false })
  enquiryDocumentModalElement: ElementRef<HTMLElement>;

  getEnumEnquiryTypeLabel = getEnumEnquiryTypeLabel;
  getEnumEnquiryStatusLabel = getEnumEnquiryStatusLabel;
  getEnquiryStatusColor = getEnquiryStatusColor;
  getEnquiryBreadcrumbTitle = getEnquiryBreadcrumbTitle;
  getEnumCurrencySymbol = getEnumCurrencySymbol;
  getEnumCurrencyLabel = getEnumCurrencyLabel;
  getEnumEnquiryCotationStatusLabel = getEnumEnquiryCotationStatusLabel;
  getEnumEnquiryCancelledReasonLabel = getEnumEnquiryCancelledReasonLabel;
  getDisplayedEnquiryRefTitle = getDisplayedEnquiryRefTitle;
  getEnumInvoiceTypeLabel = getEnumInvoiceTypeLabel;
  getUserFullname = getUserFullname;

  translateLabel(key: string): string {
    return this.translateService.instant(key);
  }

  EnumEnquiryType = EnumEnquiryType;
  EnumEnquiryStatus = EnumEnquiryStatus;
  EnumEnquiryCotationStatus = EnumEnquiryCotationStatus;
  EnumEnquiryCancelledReason = EnumEnquiryCancelledReason;
  EnumAcmiType = EnumAcmiType;
  faPlus = faPlus;

  statusLabelObj: {
    [key: string]: {
      title: string;
      position: number;
    };
  } = {
    'waiting-for-answer': {
      title: 'En attente',
      position: 3
    },
    answered: {
      title: 'Répondu',
      position: 1
    },
    rejected: {
      title: 'Rejetée',
      position: 4
    },
    'to-contact': {
      title: 'Compagnie à contacter',
      position: 2
    },
    confirmed: {
      title: 'Confirmée',
      position: 0
    },
    cancelled: {
      title: 'Annulée',
      position: 4
    }
  };

  EnumAcl = EnumAcl;

  defaultCurrency = EnumCurrency.EUR;

  loading = true;
  creatingPipedriveDeal = false;
  enquiryId: string;
  enquiry: IEnquiry;
  enquiryOffers: IEnquiryOffer[] = [];
  enquiryCotations: IEnquiryCotation[] = [];
  enquiryCotationsByOffers: {
    [key: string]: {
      offer: IEnquiryOffer;
      cotations: IEnquiryCotation[];
    };
  } = {};
  client: IPipedriveOrganization | null = null;
  contact: IPipedrivePerson | null = null;
  isLogged = false;
  aircraftsCompiledObj: { [key: string]: IAircraftCompiled | null } = {};
  airlinesObj: { [key: string]: IAirline | null } = {};
  form: FormGroup;
  saving = false;
  itinerariesList: {
    title: string;
    value: string;
  }[] = [];
  itinerariesTitleObj: { [key: string]: string } = {};
  legsList: Record<string, any> = {};
  legsObj: Record<string, any> = {};
  cotationsList: {
    title: string;
    cotationId: string;
  }[] = [];
  aircraftModelsObj: { [key: string]: IAircraftModel | null } = {};
  fields: {
    title: string;
    code: string;
  }[] = [];
  lines: CotationLine[] = [];
  user: IUser | null = null;
  loadingProcessedByUser = false;
  processedByUser: IUser | null = null;
  airportsObj: { [key: string]: IAirport | null } = {};
  airportsToLoad: string[] = [];
  airlinesAircrafts: Record<string, any> = {};
  selectedConfirmedCotationsId: string[] = [];

  lastEnquiry: IEnquiry;

  quotations: IQuotation[] = [];
  invoices: IInvoice[] = [];
  flightBriefs: IFlightBrief[] = [];

  loadingInvoices = false;
  loadingQuotations = false;
  loadingFlightBriefs = false;

  bankAccountsObj: { [bankAccountId: string]: IBankAccount } = {};

  invoiceGetAmountSoldePaid = invoiceGetAmountSoldePaid;
  invoiceGetAmountSoldeLeft = invoiceGetAmountSoldeLeft;
  invoiceDiffDueDate = invoiceDiffDueDate;
  getInvoiceTitle = getInvoiceTitle;

  getQuotationStatusLabel = getQuotationStatusLabel;
  getLanguageLabel = getLanguageLabel;
  getDefaultCurrency = getDefaultCurrency;
  getCountryLabel = getCountryLabel;

  faArrowRightArrowLeft = faArrowRightArrowLeft;
  faArrowUp = faArrowUp;
  faArrowDown = faArrowDown;
  faWarning = faWarning;
  faCheck = faCheck;
  faCopy = faCopy;
  faEdit = faEdit;
  faTrash = faTrash;
  faExternalLink = faExternalLink;

  enquiryFlights: IEnquiryFlight[] = [];
  loadingEnquiryFlights = false;
  enquiryDocuments: IEnquiryDocument[] = [];
  loadingEnquiryDocuments = false;
  addingEnquiryDocument = false;
  enquiryDocumentName = '';
  enquiryDocumentFile: File | null = null;
  usersObj: { [id: string]: IUser } = {};

  openCFMU = false;
  initFirstCFMU = false;

  subscriptions = new Subscription();
  private subscriptionsFlights = new Subscription();

  formatBytes = formatBytes;

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(() => {
      this.enquiryId = this.activatedRoute.snapshot.paramMap.get('enquiryId');

      if (this.router.url.includes('cfmu')) {
        this.openCFMU = true;
      }

      this.loadData();
    });
  }

  getEnquiryStatus(): EnumEnquiryStatus[] {
    return Object.values(EnumEnquiryStatus);
  }

  updateFloatingScroll(): void {
    window.$('.table-responsive').floatingScroll('init', {
      orientation: 'horizontal'
    });
  }

  openDropdownCotationStatus(): void {
    // Fix bug on safari where dropdown not displaying if not scrolling
    const currentTopPosition: number =
      document.documentElement.scrollTop || document.body.scrollTop;
    window.scrollTo(0, currentTopPosition - 1);
    setTimeout(() => {
      window.scrollTo(0, currentTopPosition + 1);
    }, 300);
  }

  ngOnDestroy(): void {
    window.$('.table-responsive').floatingScroll('destroy');

    this.removeModal();

    this.subscriptions.unsubscribe();
    this.subscriptionsFlights.unsubscribe();
  }

  removeModal(): void {
    this.enquiryConfirmedModalComponent?.hideModal();
    this.enquiryCancelledModalComponent?.hideModal();
    if (this.enquiryDocumentModalElement) {
      window.$(this.enquiryDocumentModalElement.nativeElement).modal('hide');
    }
    window.$('body').removeClass('modal-open');
    window.$('.modal-backdrop').remove();
  }

  async loadData(): Promise<void> {
    if (this.isLogged || (!this.isLogged && window.location.href.match('public') !== null)) {
      await this.aircraftModelService.loadAircraftModels();
      this.loadEnquiry();
      this.loadEnquiryFlights();
      this.loadEnquiryInvoices();
      this.loadEnquiryQuotations();
      this.loadEnquiryDocuments();
      this.loadBankAccounts();
      this.loadFlightBriefs();
      this.loadUsers();
    } else {
      setTimeout(() => {
        this.loadData();
      }, 500);
    }
  }

  async copyPublicUrl(): Promise<void> {
    const url = window.location.origin + '/public/enquiry/' + this.enquiryId;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        alert('L\'url a été copiée');
        return;
      }
    } catch (err) {
      console.log('Oops, impossible de copier');
    }
    window.prompt('Copiez dans le presse-papier: Ctrl+C ou Command+C, Entrer', url);
  }

  loadLastContractedEnquiryOfMonth(): void {
    const currentMonth: number = getMonth(new Date()) + 1;
    const currentYear: number = parseInt(format(new Date(), 'yy'), 0);

    if (this.enquiry) {
      this.subscriptions.add(
        this.enquiryService
          .getLatestEnquiryOfMonth(true, currentYear, currentMonth)
          .subscribe((lastEnquiry: IEnquiry) => {
            this.lastEnquiry = lastEnquiry;
          })
      );
    }
  }

  loadEnquiry(): void {
    this.loading = true;

    this.subscriptions.add(
      this.enquiryService.getFromId(this.enquiryId).subscribe(async (enquiry: IEnquiry) => {
        this.enquiry = enquiry;
        this.checkUserCanAccessEnquiryType();

        if (this.enquiry) {
          this.breadcrumbsService.setCurrentItem({
            id: this.enquiry.id,
            text: getEnquiryBreadcrumbTitle(this.enquiry)
          });
        }

        if (this.openCFMU) {
          this.triggerCFMUAction();
        }

        this.loadProcessedByUser();
        this.loadEnquiryOffers();
        this.loadEnquiryCotations();

        this.loadLastContractedEnquiryOfMonth();

        await this.loadAirportsOfEnquiry();

        let fields: {
          title: string;
          code: string;
        }[] = [
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.STATUS',
            code: 'statusTitle'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.AIRLINE',
            code: 'airlineTitle'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.COUNTRY',
            code: 'airlineCountryTitle'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.LEGS',
            code: 'legsTitle'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.AIRCRAFT',
            code: 'aircraftTitle'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.AGE_AVERAGE',
            code: 'ageAverage'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.CAPACITY',
            code: 'capacityAircraft'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.WEIGHT',
            code: 'weightAircraft'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.VOLUME',
            code: 'volumeAircraft'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.NB_PAX',
            code: 'nbPax'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.BUYING_PRICE',
            code: 'buyingPrice'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.TAXES',
            code: 'taxes'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.CATERING',
            code: 'catering'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.BUYING_PRICE_TC_CC',
            code: 'priceNetTTC'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.PRICE_PP',
            code: 'pricePP'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.SELLING_PRICE',
            code: 'sellingPrice'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.MARGIN',
            code: 'margin'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.MARGIN_PERCENT',
            code: 'marginPercent'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.SELLING_PRICE_PP',
            code: 'sellingPricePP'
          },
          {
            title: 'ENQUIRIES.AIRLINES_QUOTING.NOTES',
            code: 'notes'
          }
        ];

        if (this.enquiry?.type === EnumEnquiryType.acmi) {
          fields = [
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.STATUS',
              code: 'statusTitle'
            },
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.AIRLINE',
              code: 'airlineTitle'
            },
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.COUNTRY',
              code: 'airlineCountryTitle'
            },
            {
              title: 'ENQUIRIES.ACMI.AIRCRAFT_TYPE',
              code: 'acmiAircraftType'
            },
            {
              title: 'ENQUIRIES.ACMI.AIRCRAFT_VERSION',
              code: 'acmiAircraftVersion'
            },
            {
              title: 'ENQUIRIES.ACMI.DATE_START',
              code: 'acmiDateStart'
            },
            {
              title: 'ENQUIRIES.ACMI.DATE_END',
              code: 'acmiDateEnd'
            },
            {
              title: 'ENQUIRIES.ACMI.BH_MINIMUM_PER_MONTH',
              code: 'acmiBhMinimumPerMonth'
            },
            {
              title: 'ENQUIRIES.ACMI.MINIMUM_CYCLE_RATIO',
              code: 'acmiMinimumCycleRatio'
            },
            {
              title: 'ENQUIRIES.ACMI.BASE',
              code: 'acmiBase'
            },
            {
              title: 'ENQUIRIES.ACMI.ROUTING_AIRPORTS',
              code: 'acmiRouting'
            },
            {
              title: 'ENQUIRIES.ACMI.NB_CREW',
              code: 'acmiNbCrew'
            },
            {
              title: 'ENQUIRIES.ACMI.PERS_DIEM',
              code: 'acmiPerDiemsIncluded'
            },
            {
              title: 'ENQUIRIES.ACMI.HOTAC',
              code: 'acmiCrewHotacIncluded'
            },
            {
              title: 'ENQUIRIES.ACMI.ADDITIONAL_INSURANCE',
              code: 'acmiHasAdditionalInsurance'
            },
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.BUYING_PRICE',
              code: 'buyingPrice'
            },
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.BUYING_PRICE_TC_CC',
              code: 'priceNetTTC'
            },
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.SELLING_PRICE',
              code: 'sellingPrice'
            },
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.MARGIN',
              code: 'margin'
            },
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.MARGIN_PERCENT',
              code: 'marginPercent'
            },
            {
              title: 'ENQUIRIES.AIRLINES_QUOTING.NOTES',
              code: 'notes'
            }
          ];

          if (this.enquiry?.acmiType === EnumAcmiType.cargo) {
            const weightMaxIndex = 15;
            fields.splice(weightMaxIndex, 0, {
              title: 'ENQUIRIES.ACMI.WEIGHT_MAX',
              code: 'acmiWeightMax'
            });
            fields.splice(weightMaxIndex + 1, 0, {
              title: 'ENQUIRIES.ACMI.VOLUME_MAX',
              code: 'acmiVolumeMax'
            });
          }
        }

        this.fields = [];
        if (this.enquiry?.type === EnumEnquiryType.cargo) {
          for (const field of fields) {
            if (
              [
                'capacityAircraft',
                'nbPax',
                'taxes',
                'catering',
                'pricePP',
                'sellingPricePP'
              ].indexOf(field.code) === -1
            ) {
              this.fields.push(field);
            }
          }
        } else {
          for (const field of fields) {
            if (['weightAircraft', 'volumeAircraft'].indexOf(field.code) === -1) {
              this.fields.push(field);
            }
          }
        }

        this.legsList = {};
        this.itinerariesTitleObj = {};
        this.itinerariesList = [];

        if (this.enquiry?.itineraries) {
          for (const itineraryIndex of Object.keys(this.enquiry.itineraries ?? {})) {
            this.itinerariesList.push({
              title: this.enquiry.itineraries[itineraryIndex]?.title,
              value: this.enquiry.itineraries[itineraryIndex].id
            });
            this.itinerariesTitleObj[this.enquiry.itineraries[itineraryIndex].id] =
              this.enquiry.itineraries[itineraryIndex]?.title;

            for (const trip of this.enquiry.itineraries[itineraryIndex].trips) {
              const title: string[] = [];
              const airports: string[] = [];

              title.push(
                this.airportsObj[trip.airportDepart]?.iataCode
                  ? this.airportsObj[trip.airportDepart]?.iataCode
                  : this.airportsObj[trip.airportDepart]?.title
              );
              airports.push(this.airportsObj[trip.airportDepart]?.iataCode);

              if (trip.hasCommercialStopOver) {
                title.push(
                  'STOP ' +
                    (this.airportsObj[trip.commercialStopOverAirport]?.iataCode
                      ? this.airportsObj[trip.commercialStopOverAirport]?.iataCode
                      : this.airportsObj[trip.commercialStopOverAirport]?.title)
                );
                airports.push(this.airportsObj[trip.commercialStopOverAirport]?.iataCode);
              }

              if (trip.hasFuelStopOver) {
                title.push(
                  'FUEL ' +
                    (this.airportsObj[trip.fuelStopOverAirport]?.iataCode
                      ? this.airportsObj[trip.fuelStopOverAirport]?.iataCode
                      : this.airportsObj[trip.fuelStopOverAirport]?.title)
                );
                airports.push(this.airportsObj[trip.fuelStopOverAirport]?.iataCode);
              }

              title.push(
                this.airportsObj[trip.airportDestination]?.iataCode
                  ? this.airportsObj[trip.airportDestination]?.iataCode
                  : this.airportsObj[trip.airportDestination]?.title
              );
              airports.push(this.airportsObj[trip.airportDestination]?.iataCode);

              if (!this.legsList[this.enquiry.itineraries[itineraryIndex].id]) {
                this.legsList[this.enquiry.itineraries[itineraryIndex].id] = [];
              }

              const titleStr: string = title.join(' -> ');

              this.legsList[this.enquiry.itineraries[itineraryIndex].id].push({
                title: titleStr,
                value: trip.id,
                airports: [...new Set(airports)]
              });

              this.legsObj[trip.id] = {
                airportDepart: this.airportsObj[trip.airportDepart]?.title,
                airportDepartCode: trip.airportDepart,
                airportDestination: this.airportsObj[trip.airportDestination]?.title,
                airportDestinationCode: trip.airportDestination,
                commercialStopOverAirport:
                  trip.commercialStopOverAirport && this.airportsObj[trip.commercialStopOverAirport]
                    ? this.airportsObj[trip.commercialStopOverAirport]?.title
                    : '',
                commercialStopOverAirportCode: trip.commercialStopOverAirport,
                fuelStopOverAirport:
                  trip.fuelStopOverAirport && this.airportsObj[trip.fuelStopOverAirport]
                    ? this.airportsObj[trip.fuelStopOverAirport]?.title
                    : '',
                fuelStopOverAirportCode: trip.fuelStopOverAirport,
                title: titleStr,
                value: trip.id,
                nbPax: trip.passengersTotal
              };
            }
          }
        }

        this.updateLines();

        await this.loadClient();
        await this.fetchAircraftsAndFlightCompanies();

        // We add confirmed cotation variable
        if (this.enquiry?.cotationConfirmedIds) {
          this.selectedConfirmedCotationsId = [...this.enquiry.cotationConfirmedIds];
        }

        this.loading = false;
      })
    );
  }

  checkUserCanAccessEnquiryType(): void {
    if (this.router.url.includes('/public/')) {
      return;
    }

    if (!this.user || !this.enquiry) {
      return;
    }

    const userEnquiryTypes: EnumEnquiryType[] = this.user.enquiryTypes || [];

    if (!userEnquiryTypes.includes(this.enquiry.type)) {
      this.router.navigate(['/not-authorised']);
    }
  }

  triggerCFMUAction(): void {
    if (!this.initFirstCFMU && this.enquiry && this.hasAclAccess(EnumAcl.enquiriesSwitchStatus)) {
      this.initFirstCFMU = !this.initFirstCFMU;

      if (
        ![EnumEnquiryStatus.cancelled, EnumEnquiryStatus.confirmed].includes(this.enquiry.status)
      ) {
        this.changeStatus(EnumEnquiryStatus.cancelled);
      }
    }
  }

  loadEnquiryOffers(): void {
    this.subscriptions.add(
      this.enquiryOfferService
        .getAllForEnquiry(this.enquiryId)
        .subscribe(async (enquiryOffers: IEnquiryOffer[]) => {
          this.enquiryOffers = enquiryOffers;

          this.refreshEnquiryCotationsByOffers();
        })
    );
  }

  loadEnquiryCotations(): void {
    this.subscriptions.add(
      this.enquiryCotationService
        .getAllForEnquiry(this.enquiryId)
        .subscribe(async (enquiryCotations: IEnquiryCotation[]) => {
          this.enquiryCotations = enquiryCotations;

          this.refreshEnquiryCotationsByOffers();
        })
    );
  }

  loadEnquiryInvoices(): void {
    this.invoices = [];

    if (this.enquiryId) {
      this.loadingInvoices = true;

      this.subscriptions.add(
        this.invoiceService.getAllForEnquiry(this.enquiryId).subscribe((invoices: IInvoice[]) => {
          this.invoices = invoices;

          this.loadingInvoices = false;
        })
      );
    }
  }

  loadFlightBriefs(): void {
    this.flightBriefs = [];

    if (this.enquiryId) {
      this.loadingFlightBriefs = true;

      this.subscriptions.add(
        this.flightBriefService
          .getAllForEnquiry(this.enquiryId)
          .subscribe((flightBriefs: IFlightBrief[]) => {
            this.flightBriefs = flightBriefs;

            this.loadingFlightBriefs = false;
          })
      );
    }
  }

  loadEnquiryQuotations(): void {
    this.quotations = [];

    if (this.enquiryId) {
      this.loadingQuotations = true;

      this.subscriptions.add(
        this.quotationService
          .getAllForEnquiry(this.enquiryId)
          .subscribe((quotations: IQuotation[]) => {
            this.quotations = quotations;

            this.loadingQuotations = false;
          })
      );
    }
  }

  refreshEnquiryCotationsByOffers(): void {
    this.enquiryCotationsByOffers = {};

    for (const enquiryOffer of this.enquiryOffers) {
      this.enquiryCotationsByOffers[enquiryOffer.id] = {
        offer: enquiryOffer,
        cotations: []
      };
    }

    for (const enquiryCotation of this.enquiryCotations) {
      if (this.enquiryCotationsByOffers[enquiryCotation.offerId]) {
        this.enquiryCotationsByOffers[enquiryCotation.offerId].cotations.push(enquiryCotation);
      }
    }

    this.updateLines();
  }

  updateLines(): void {
    if (this.enquiry) {
      this.lines = [];

      for (const offerId of Object.keys(this.enquiryCotationsByOffers ?? {})) {
        const offer: IEnquiryOffer = this.enquiryCotationsByOffers[offerId].offer;
        if (this.enquiryCotationsByOffers[offerId].cotations?.length) {
          for (const cotation of this.enquiryCotationsByOffers[offerId].cotations) {
            let aircraftCompiled: IAircraftCompiled | null = null;

            if (cotation.aircraftCompiled) {
              aircraftCompiled = cotation.aircraftCompiled;
            } else if (offer.aircraftCompiled) {
              aircraftCompiled = offer.aircraftCompiled;
            }

            const line: CotationLine = {
              enquiryId: offer.enquiryId,
              offerId: offer.id,
              cotationId: cotation.id,
              status: cotation.status ?? offer.status,
              statusTitle:
                this.statusLabelObj[cotation.status ? cotation.status : offer.status]?.title,
              followedUp: offer.followedUp,
              airlineId: null,
              airlineTitle: null,
              airlineCountryCode: null,
              airlineCountryTitle: null,
              itineraryId: cotation.itineraryId,
              itineraryTitle: this.itinerariesTitleObj[cotation.itineraryId],
              legsId: cotation.legsId,
              isNationalFlight: false,
              legsAirportsCode: [],
              legsTitle: '',
              aircraftCompiledId: aircraftCompiled?.id ?? null,
              aircraftCompiledModel: aircraftCompiled?.model ?? null,
              aircraftTitle: aircraftCompiled?.type ?? null,
              ageAverage: aircraftCompiled?.ageAverage ?? null,
              aircraftErrorMessages: [],
              capacityAircraft: aircraftCompiled?.seatTotal ?? null,
              weightAircraft: aircraftCompiled?.weight ?? null,
              volumeAircraft: aircraftCompiled?.volume ?? null,
              nbPax: cotation.nbPax,
              currency: cotation.currency,
              buyingPrice: cotation.buyingPrice,
              buyingPriceInCurrency: cotation.buyingPriceInCurrency,
              taxesTotalPax: cotation.taxesTotalPax,
              taxesTotalPaxInCurrency: cotation.taxesTotalPaxInCurrency,
              catering: cotation.cateringByPerson * cotation.nbPax,
              cateringInCurrency: cotation.cateringByPersonInCurrency * cotation.nbPax,
              priceNetTTC: cotation.priceNetTTC,
              priceNetTTCInCurrency: cotation.priceNetTTCInCurrency,
              pricePP: cotation.pricePP,
              pricePPInCurrency: cotation.pricePPInCurrency,
              sellingPrice: cotation.sellingPrice,
              sellingPriceInCurrency: cotation.sellingPriceInCurrency,
              margin: cotation.margin,
              marginInCurrency: cotation.marginInCurrency,
              marginPercent: cotation.marginPercent,
              marginPercentInCurrency: cotation.marginPercentInCurrency,
              marginOnConfirmed:
                typeof cotation.marginOnConfirmed !== 'undefined'
                  ? cotation.marginOnConfirmed
                  : null,
              sellingPricePP: cotation.sellingPricePP,
              sellingPricePPInCurrency: cotation.sellingPricePPInCurrency,
              notes: cotation.notes ? cotation.notes : '',
              acmiAircraftType: cotation?.acmiAircraftType || null,
              acmiAircraftVersion: cotation?.acmiAircraftVersion || null,
              acmiDateStart: cotation?.acmiDateStart || null,
              acmiDateEnd: cotation?.acmiDateEnd || null,
              acmiBhMinimumPerMonth: cotation?.acmiBhMinimumPerMonth || null,
              acmiMinimumCycleRatio: cotation?.acmiMinimumCycleRatio || null,
              acmiBhRate: cotation?.acmiBhRate || null,
              acmiBase: cotation?.acmiBase || null,
              acmiRouting: cotation?.acmiRouting || null,
              acmiNbCrew: cotation?.acmiNbCrew || null,
              acmiPerDiemsIncluded: cotation?.acmiPerDiemsIncluded || null,
              acmiPerDiems: cotation?.acmiPerDiems || null,
              acmiCrewHotacIncluded: cotation?.acmiCrewHotacIncluded || null,
              acmiCrewHotac: cotation?.acmiCrewHotac || null,
              acmiHasAdditionalInsurance: cotation?.acmiHasAdditionalInsurance || null,
              acmiAdditionalInsurance: cotation?.acmiAdditionalInsurance || null,
              acmiWeightMax: cotation?.acmiWeightMax || null,
              acmiVolumeMax: cotation?.acmiVolumeMax || null
            };

            if (cotation?.airlineId) {
              line.airlineId = cotation.airlineId;
            } else if (offer?.airlineId) {
              line.airlineId = offer.airlineId;
            } else if (aircraftCompiled?.airlineId) {
              line.airlineId = aircraftCompiled.airlineId;
            }

            if (cotation?.airlineTitle) {
              line.airlineTitle = cotation.airlineTitle;
            } else if (offer?.airline) {
              line.airlineTitle = offer.airline.title;
            } else if (aircraftCompiled?.airlineTitle) {
              line.airlineTitle = aircraftCompiled.airlineTitle;
            }

            if (cotation?.airlineCountryCode) {
              line.airlineCountryCode = cotation.airlineCountryCode;
            } else if (offer?.airline) {
              line.airlineCountryCode = offer.airline.countryCode;
            } else if (aircraftCompiled?.airlineCountryCode) {
              line.airlineCountryCode = aircraftCompiled.airlineCountryCode;
            }

            if (line.airlineCountryCode) {
              line.airlineCountryTitle = getCountryLabel(line.airlineCountryCode);
            }

            for (const legId of line.legsId) {
              line.legsAirportsCode.push(
                this.legsObj[legId] ? this.legsObj[legId]?.title : 'Leg supprimé'
              );

              if (this.legsObj[legId]) {
                if (
                  this.airportsObj[this.legsObj[legId].airportDepart] &&
                  this.airportsObj[this.legsObj[legId].airportDestination] &&
                  this.airportsObj[this.legsObj[legId].airportDepart].countryCode ===
                    this.airportsObj[this.legsObj[legId].airportDestination].countryCode
                ) {
                  line.isNationalFlight = true;
                }
              }
            }

            if (this.enquiry.itineraries?.length > 1) {
              line.legsTitle = line.itineraryTitle + '<br>';
            }
            line.legsTitle += line.legsAirportsCode.join('<br>');
            this.lines.push(line);
          }
        } else {
          const line: CotationLine = {
            enquiryId: offer.enquiryId,
            offerId: offer.id,
            cotationId: null,
            status: offer.status,
            statusTitle: this.statusLabelObj[offer.status]?.title,
            followedUp: offer.followedUp,
            airlineId: null,
            airlineTitle: null,
            airlineCountryCode: null,
            airlineCountryTitle: null,
            itineraryId: null,
            itineraryTitle: null,
            legsId: [],
            isNationalFlight: false,
            legsAirportsCode: [],
            legsTitle: '',
            aircraftErrorMessages: [],
            aircraftCompiledId: null,
            aircraftCompiledModel: null,
            aircraftTitle: null,
            ageAverage: null,
            capacityAircraft: null,
            weightAircraft: null,
            volumeAircraft: null,
            nbPax: null,
            currency: null,
            buyingPrice: null,
            buyingPriceInCurrency: null,
            taxesTotalPax: null,
            taxesTotalPaxInCurrency: null,
            catering: null,
            cateringInCurrency: null,
            priceNetTTC: null,
            priceNetTTCInCurrency: null,
            pricePP: null,
            pricePPInCurrency: null,
            sellingPrice: null,
            sellingPriceInCurrency: null,
            margin: null,
            marginInCurrency: null,
            marginPercent: null,
            marginPercentInCurrency: null,
            marginOnConfirmed: null,
            sellingPricePP: null,
            sellingPricePPInCurrency: null,
            notes: ''
          };

          if (offer.aircraftCompiled) {
            line.airlineId = offer.aircraftCompiled.airlineId;
            line.airlineTitle = offer.aircraftCompiled.airlineTitle;
            line.airlineCountryCode = offer.aircraftCompiled.airlineCountryCode;
            line.airlineCountryTitle = getCountryLabel(offer.aircraftCompiled.airlineCountryCode);
            line.aircraftCompiledId = offer.aircraftCompiled.id;
            line.aircraftCompiledModel = offer.aircraftCompiled.model;
            line.aircraftTitle = offer.aircraftCompiled.type;
            line.ageAverage = offer.aircraftCompiled.ageAverage;
            line.capacityAircraft = offer.aircraftCompiled.seatTotal;
            line.weightAircraft = offer.aircraftCompiled.weight;
            line.volumeAircraft = offer.aircraftCompiled.volume;
          } else if (offer.airline) {
            line.airlineId = offer.airline.id;
            line.airlineTitle = offer.airline.title;
            line.airlineCountryCode = offer.airline.countryCode;
            line.airlineCountryTitle = getCountryLabel(offer.airline.countryCode);
          } else if (offer.airlineId) {
            line.airlineId = offer.airline.id;
          }

          this.lines.push(line);
        }
      }

      for (const line of this.lines) {
        // Check if problem with aircraft
        for (const itinerary of (this.enquiry.itineraries ?? [])) {
          for (const trip of itinerary.trips) {
            if (
              line.legsId.includes(trip.id) &&
              line.aircraftCompiledModel &&
              this.aircraftModelsObj[line.aircraftCompiledModel]
            ) {
              const aircraftModel: IAircraftModel =
                this.aircraftModelsObj[line.aircraftCompiledModel];

              if (
                aircraftModel &&
                aircraftModel.rangeInKms &&
                trip.distanceInKm > aircraftModel.rangeInKms
              ) {
                let text: string =
                  'Ce modèle d\'avion n\'a pas l\'autonomie suffisante (' +
                  aircraftModel.rangeInKms +
                  ' kms) <br>' +
                  'pour faire le trajet <em>';

                if (this.enquiry.itineraries?.length > 1) {
                  text += itinerary?.title + ' / ';
                }
                text +=
                  this.airportsObj[trip.airportDepart]?.title +
                  ' -> ' +
                  this.airportsObj[trip.airportDestination]?.title;

                text += '</em> (distance: ' + this.roundNumber(trip.distanceInKm) + ' kms). <br>';
                text += 'Veuillez ajouter au moins une escale.';

                line.aircraftErrorMessages.push(text);
              }
            }
          }
        }
      }

      this.sortingLines();
    }
  }

  async loadClient(): Promise<void> {
    if (this.enquiry?.clientId) {
      this.client = await this.pipedriveService.getOrganization(
        typeof this.enquiry.clientId === 'number'
          ? this.enquiry.clientId.toString()
          : this.enquiry.clientId
      );
    }

    if (this.enquiry?.contactId) {
      this.contact = await this.pipedriveService.getPerson(this.enquiry.contactId);
    }
  }

  async fetchAircraftsAndFlightCompanies(): Promise<void> {
    if (this.enquiry) {
      const aircraftsCompiledId: string[] = [];

      for (const enquiryOffer of this.enquiryOffers) {
        aircraftsCompiledId.push(enquiryOffer.aircraftCompiledId);
      }

      if (aircraftsCompiledId.length) {
        const aircraftsCompiledList: Record<string, any>[] = await this.appDataService.getDocumentsFromDocId(
          'aircraftsCompiled',
          aircraftsCompiledId
        );

        for (const aircraftCompiledObj of aircraftsCompiledList) {
          this.aircraftsCompiledObj[aircraftCompiledObj.id] =
            aircraftCompiledObj as IAircraftCompiled;
        }
      }

      const airlinesId: string[] = [];
      for (const aircraftCompiledId of Object.keys(this.aircraftsCompiledObj ?? {})) {
        airlinesId.push(this.aircraftsCompiledObj[aircraftCompiledId].airlineId);
      }

      if (airlinesId.length) {
        const airlinesList: Record<string, any>[] = await this.appDataService.getDocumentsFromDocId(
          'airlines',
          airlinesId
        );

        for (const airlineObj of airlinesList) {
          this.airlinesObj[airlineObj.id] = airlineObj as IAirline;
        }
      }

      this.loading = false;
    }
  }

  sortingLines(): void {
    this.lines.sort(
      (a, b) =>
        (this.statusLabelObj[a.status]?.position ?? Number.MAX_SAFE_INTEGER) -
        (this.statusLabelObj[b.status]?.position ?? Number.MAX_SAFE_INTEGER)
    );
    this.loading = false;
  }

  roundNumber(value: number): number {
    return Math.round(value * 100 + Number.EPSILON) / 100;
  }

  relanceOffer(offerId: string): void {
    alert('Cette fonctionnalité est en cours de développement.');
  }

  async delete(): Promise<void> {
    if (this.hasAclAccess(EnumAcl.enquiriesDelete)) {
      const result: boolean = confirm(
        'La suppression de cette demande sera permanente. Êtes-vous sûr de vouloir continuer?'
      );

      if (result) {
        try {
          await this.enquiryService.delete(this.enquiryId);

          alert('La suppression a été effectuée avec succès.');

          this.router.navigate(['/admin']);
        } catch (err) {
          console.log(err);
          alert(err.message);
        }
      }
    }
  }

  changeEnquiryDocumentInputFile(file: File): void {
    if (file) {
      this.enquiryDocumentFile = file;

      if (!this.enquiryDocumentName?.trim()) {
        this.enquiryDocumentName = this.enquiryDocumentFile.name;
      }
    }
  }

  openAddEnquiryDocumentModal(): void {
    this.enquiryDocumentName = '';
    this.enquiryDocumentFile = null;
    this.enquiryDocumentFileInputElement?.reset();
    window.$(this.enquiryDocumentModalElement.nativeElement).modal('show');
  }

  async addEnquiryDocument(): Promise<void> {
    if (!this.enquiry?.id || !this.enquiryDocumentFile || this.addingEnquiryDocument) {
      return;
    }

    if (!this.hasAclAccess(EnumAcl.enquiriesAddDocument)) {
      return;
    }

    this.addingEnquiryDocument = true;
    const file = this.enquiryDocumentFile;
    const name = this.enquiryDocumentName?.trim() || file.name;

    try {
      const result = this.appDataService.upload(
        'enquiries/documents',
        generateRandomId(),
        file
      );

      await lastValueFrom(this.appDataService.fromTask(result.task));
      const downloadUrl = await getDownloadURL(result.ref);

      await this.enquiryDocumentService.create({
        name,
        enquiryId: this.enquiry.id,
        position:
          this.enquiryDocuments.length > 0
            ? Math.max(
                ...this.enquiryDocuments.map((document: IEnquiryDocument) => document.position ?? 0)
              ) + 1
            : 0,
        document: {
          name: file.name,
          type: file.type,
          size: file.size,
          url: downloadUrl
        } as IFile,
        id: null,
        created: null,
        modified: null,
        createdBy: this.user?.id,
        modifiedBy: this.user?.id
      });

      this.enquiryDocumentName = '';
      this.enquiryDocumentFile = null;
      this.enquiryDocumentFileInputElement?.reset();

      window.$(this.enquiryDocumentModalElement.nativeElement).modal('hide');
    } catch {
      this.enquiryDocumentFileInputElement?.showError('GENERAL.FILE_INPUT.UPLOAD_FAILED');
    } finally {
      this.addingEnquiryDocument = false;
    }
  }

  async deleteEnquiryDocument(documentId: string): Promise<void> {
    if (!this.enquiry?.id || !documentId) {
      return;
    }

    if (!this.hasAclAccess(EnumAcl.enquiriesDeleteDocument)) {
      return;
    }

    const result: boolean = confirm(
      'La suppression de ce document sera définitive. Êtes-vous sûr de vouloir continuer ?'
    );

    if (!result) {
      return;
    }

    this.loaderService.presentLoader();

    try {
      await this.enquiryDocumentService.delete(documentId);

      await this.loaderService.hideLoaderOnSuccess();
    } catch (err: any) {
      await this.loaderService.hideLoaderOnFailure(err?.message ?? err);
    }
  }

  async editEnquiryDocumentName(document: IEnquiryDocument): Promise<void> {
    if (!document?.id) {
      return;
    }
    this.alertService.presentAlert({
      size: EnumAlertOptionSize.small,
      header: {
        display: true,
        title: 'GENERAL.EDIT'
      },
      body: {
        input: {
          value: document.name,
          placeholder: 'GENERAL.NAME'
        }
      },
      footer: {
        display: true,
        align: EnumAlertOptionFlexAlign.between,
        buttons: [
          {
            text: 'GENERAL.CANCEL',
            closeModal: true,
            btnClass: 'btn-secondary'
          },
          {
            text: 'GENERAL.SAVE',
            closeModal: true,
            callback: async (value: string) => {
              const trimmedName = (value || '').trim();

              if (!trimmedName || trimmedName === document.name) {
                return;
              }

              this.loaderService.presentLoader();

              try {
                await this.enquiryDocumentService.update({
                  ...document,
                  name: trimmedName
                } as IEnquiryDocument);

                await this.loaderService.hideLoaderOnSuccess();
              } catch (err: any) {
                await this.loaderService.hideLoaderOnFailure(err?.message ?? err);
              }
            }
          }
        ]
      }
    });
  }

  async loadAirlineAircrafts(airlineId: string): Promise<void> {
    if (!this.airlinesAircrafts[airlineId] || !this.airlinesAircrafts[airlineId].length) {
      this.airlinesAircrafts[airlineId] = await this.aircraftCompiledService.getAllForAirlineModel(
        airlineId,
        this.enquiry.type === EnumEnquiryType.cargo
      );
    }
  }

  changeStatus(newStatus: EnumEnquiryStatus): void {
    if (this.hasAclAccess(EnumAcl.enquiriesSwitchStatus)) {
      if (
        this.enquiry.status === EnumEnquiryStatus.confirmed &&
        !this.hasAclAccess(EnumAcl.enquiriesSwitchStatusFromConfirmed)
      ) {
        alert('Vous n\'avez pas les autorisations nécessaires pour modifier une demande confirmée.');
      } else {
        if (newStatus === EnumEnquiryStatus.cancelled) {
          this.showCancellationModal();
        } else if (newStatus === EnumEnquiryStatus.confirmed) {
          let noCotation = true;
          for (const offerId of Object.keys(this.enquiryCotationsByOffers ?? {})) {
            for (const cotation of this.enquiryCotationsByOffers[offerId].cotations) {
              noCotation = false;
              break;
            }
          }
          if (noCotation) {
            alert('La demande n\'a aucune cotation.');
          } else {
            this.enquiryConfirmedModalComponent?.showModal();
          }
        } else {
          this.setNewStatusToEnquiry({
            status: newStatus,
            cotationConfirmedIds: [],
            reasonCancelled: null,
            airlineIds: []
          } as IEnquiry);
        }
      }
    }
  }

  showCancellationModal(): void {
    this.enquiryCancelledModalComponent?.showModal();
  }

  saveStatusCancelled(reasonCancelled: {
    reason: EnumEnquiryCancelledReason;
    comment: string;
  }): void {
    const data: IEnquiry = {
      status: EnumEnquiryStatus.cancelled,
      cotationConfirmedIds: [],
      reasonCancelled: Object.assign({}, reasonCancelled),
      airlineIds: []
    } as IEnquiry;

    this.setNewStatusToEnquiry(data);
  }

  async resetOfferConfirmed(): Promise<void> {
    for (const offerId of Object.keys(this.enquiryCotationsByOffers ?? {})) {
      for (const cotation of this.enquiryCotationsByOffers[offerId].cotations) {
        if (cotation.status === EnumEnquiryCotationStatus.confirmed) {
          await this.changeCotationsStatus(
            [
              {
                cotation,
                offerId: cotation.offerId
              }
            ],
            EnumEnquiryCotationStatus.answered
          );
        }
      }
    }
  }

  async changeCotationsStatus(
    cotationAndOfferIds: {
      offerId: string;
      cotation: IEnquiryCotation;
    }[],
    newStatus: EnumEnquiryCotationStatus
  ): Promise<void> {
    try {
      for (const cotationAndOfferId of cotationAndOfferIds) {
        const cotationData: IEnquiryCotation = {
          id: cotationAndOfferId.cotation.id,
          status: newStatus
        } as IEnquiryCotation;

        if (newStatus === EnumEnquiryCotationStatus.confirmed) {
          cotationData.marginOnConfirmed =
            cotationAndOfferId.cotation.sellingPrice - cotationAndOfferId.cotation.priceNetTTC;
          cotationData.legs = cotationAndOfferId.cotation.legs || [];
        }

        await this.enquiryCotationService.update(cotationData);

        await this.enquiryOfferService.update({
          id: cotationAndOfferId.offerId,
          status: newStatus.toString()
        } as IEnquiryOffer);
      }

      this.updateLines();
    } catch (err) {
      console.log(err);
      alert(err.message);
    }
  }

  async setFieldDataForConfirmedEnquiry(
    data: IEnquiry,
    confirmationDate: Date = new Date()
  ): Promise<IEnquiry> {
    if (!this.enquiry.refContractNumber && !this.enquiry.refContractTitle) {
      if (shouldUseEnquiryReferenceForContract(confirmationDate)) {
        return data;
      }

      data.refContractYear = parseInt(format(confirmationDate, 'yy'), 0);
      data.refContractMonth = getMonth(confirmationDate) + 1;

      if (this.lastEnquiry) {
        data.refContractNumber = this.lastEnquiry.refContractNumber + 1;
      } else {
        data.refContractNumber = 1;
      }

      data.refContractPrefix = getEnumEnquiryPrefix(this.enquiry.type);

      data = this.setRefTitle('refContract', data);
    }

    return data;
  }

  setRefTitle(refField: string, data: IEnquiry): IEnquiry {
    if (data[refField + 'Number']) {
      data[refField + 'TitleWithoutPrefix'] = getEnquiryRefTitleWithoutPrefix(
        data[refField + 'Year'],
        data[refField + 'Month'],
        data[refField + 'Number']
      );

      data[refField + 'Title'] = getEnquiryRefTitle(
        data[refField + 'Prefix'],
        data[refField + 'Year'],
        data[refField + 'Month'],
        data[refField + 'Number']
      );
      data[refField + 'TitleWithoutPrefixDisplayed'] = getEnquiryRefTitleWithoutPrefix(
        data[refField + 'Year'],
        data[refField + 'Month'],
        data[refField + 'Number'],
        2
      );

      data[refField + 'TitleDisplayed'] = getEnquiryRefTitle(
        data[refField + 'Prefix'],
        data[refField + 'Year'],
        data[refField + 'Month'],
        data[refField + 'Number'],
        2
      );
    }

    return data;
  }

  async setNewStatusToEnquiry(data: IEnquiry): Promise<void> {
    this.loaderService.presentLoader();

    try {
      const statusChangeDate = new Date();

      if (data.status !== EnumEnquiryStatus.confirmed) {
        if (!(data.status === EnumEnquiryStatus.cancelled && this.invoices.length)) {
          await this.resetOfferConfirmed();
        }
      } else {
        data = await this.setFieldDataForConfirmedEnquiry(data, statusChangeDate);
      }

      switch (data.status) {
        case EnumEnquiryStatus.confirmed:
          data.dateConfirmed = statusChangeDate;
          data.dateCancelled = null;
          break;
        case EnumEnquiryStatus.cancelled:
          data.dateCancelled = new Date();
          data.dateConfirmed = null;

          // Don't reset cotationConfirmedIds if there are invoices
          if (this.invoices.length) {
            delete data.cotationConfirmedIds;
            delete data.airlineIds;
          }
          break;
        default:
          data.dateConfirmed = null;
          data.dateCancelled = null;
          break;
      }

      const statusPatch = Object.assign(
        {
          id: this.enquiryId
        },
        data
      ) as IEnquiry;
      if (data.status === EnumEnquiryStatus.confirmed) {
        await this.enquiryService.confirm(statusPatch, statusChangeDate);
      } else {
        await this.enquiryService.update(statusPatch);
      }

      await this.updateDealInPipedrive();

      await this.loaderService.hideLoaderOnSuccess();
    } catch (err) {
      await this.loaderService.hideLoaderOnFailure(err);
    }
  }

  async updateDataOnPipedriveDeal(): Promise<void> {
    if (this.enquiry?.pipedriveDealId) {
    }
  }

  async loadAirportsOfEnquiry(): Promise<void> {
    if (this.enquiry?.itineraries) {
      for (const itinerary of this.enquiry.itineraries) {
        for (const trip of itinerary.trips) {
          for (const field of [
            'airportDepart',
            'airportDestination',
            'commercialStopOverAirport',
            'fuelStopOverAirport'
          ]) {
            if (trip[field]) {
              this.addAirportToLoad(trip[field]);
            }
          }
        }
      }
    }

    await this.loadAirports();
  }

  addAirportToLoad(airportId: string) {
    if (
      this.airportsToLoad.indexOf(airportId) === -1 &&
      typeof this.airportsObj[airportId] === 'undefined'
    ) {
      this.airportsToLoad.push(airportId);
    }
  }

  async loadAirports(): Promise<void> {
    if (this.airportsToLoad.length) {
      const docs: Record<string, any>[] = await this.appDataService.getDocumentsFromDocId(
        'airports',
        this.airportsToLoad
      );

      for (const doc of docs) {
        const airport = doc as IAirport;

        this.airportsObj[airport.id] = airport;
      }

      this.airportsToLoad = [];
    }
  }

  hasAclAccess(id: EnumAcl): boolean {
    return this.aclService.hasAclAccess(id);
  }

  async createDealInPipedrive(): Promise<void> {
    this.creatingPipedriveDeal = true;

    const pipedriveDealId: number = await this.pipedriveService.createDealFromEnquiry(this.enquiry);

    await this.enquiryService.update({
      id: this.enquiryId,
      pipedriveDealId
    } as IEnquiry);

    this.creatingPipedriveDeal = false;
  }

  async updateDealInPipedrive(): Promise<void> {
    this.creatingPipedriveDeal = true;

    if (this.enquiry.pipedriveDealId) {
      try {
        if (this.enquiry.status && this.enquiry.pipedriveDealId) {
          switch (this.enquiry.status) {
            case EnumEnquiryStatus.draft:
              await this.pipedriveService.openDeal(this.enquiry);
              break;
            case EnumEnquiryStatus.cancelled:
              await this.pipedriveService.lostDeal(this.enquiry);
              break;
            case EnumEnquiryStatus.confirmed:
              const confirmedCotations: IEnquiryCotation[] = [];

              for (const enquiryCotation of this.enquiryCotations) {
                if (this.selectedConfirmedCotationsId.includes(enquiryCotation.id)) {
                  confirmedCotations.push(enquiryCotation);
                }
              }

              await this.pipedriveService.wonDeal(this.enquiry, confirmedCotations);
              break;
          }
        }
      } catch (err) {
        console.log(err);
      }
    }

    this.creatingPipedriveDeal = false;
  }

  async saveConfirmedCotations(payload: IConfirmedCotationsPayload): Promise<void> {
    this.selectedConfirmedCotationsId = [...(payload?.selectedConfirmedCotationsId || [])];

    const airlineIds: string[] = [];

    const cotationAndOfferIds: {
      offerId: string;
      cotation: IEnquiryCotation;
    }[] = [];
    for (const enquiryCotation of this.enquiryCotations) {
      if (this.selectedConfirmedCotationsId.includes(enquiryCotation.id)) {
        enquiryCotation.legs = payload?.cotationLegsObj?.[enquiryCotation.id] || [];

        cotationAndOfferIds.push({
          offerId: enquiryCotation.offerId,
          cotation: enquiryCotation
        });

        let airlineId: string | null = getAirlineIdFromCotation(enquiryCotation);

        if (!airlineId) {
          for (const enquiryOffer of this.enquiryOffers) {
            if (enquiryOffer.id === enquiryCotation.offerId) {
              airlineId = getAirlineIdFromOffer(enquiryOffer);
              break;
            }
          }
        }

        if (airlineId && !airlineIds.includes(airlineId)) {
          airlineIds.push(airlineId);
        }
      }
    }

    if (cotationAndOfferIds.length) {
      await this.changeCotationsStatus(cotationAndOfferIds, EnumEnquiryCotationStatus.confirmed);
    }

    const data: IEnquiry = {
      status: EnumEnquiryStatus.confirmed,
      cotationConfirmedIds: this.selectedConfirmedCotationsId,
      reasonCancelled: null,
      airlineIds
    } as IEnquiry;

    await this.setNewStatusToEnquiry(data);
  }

  async loadBankAccounts(): Promise<void> {
    const docs = await this.appDataService.getAllDocuments('bankAccounts', {
      field: 'name',
      direction: 'asc'
    });

    for (const doc of docs) {
      const bankAccount: IBankAccount = doc as IBankAccount;

      this.bankAccountsObj[bankAccount.id] = bankAccount;
    }
  }

  async reopenEnquiry(): Promise<void> {
    if (this.enquiryId) {
      try {
        this.loaderService.presentLoader();

        await this.enquiryService.update({
          id: this.enquiryId,
          isCompleted: false,
          dateCompleted: null
        } as IEnquiry);

        await this.loaderService.hideLoaderOnSuccess();
      } catch (err: any) {
        await this.loaderService.hideLoaderOnFailure(err.message);
      }
    }
  }

  loadEnquiryFlights(): void {
    if (this.enquiryId) {
      this.loadingEnquiryFlights = true;

      if (this.subscriptionsFlights) {
        this.subscriptionsFlights.unsubscribe();
      }

      this.subscriptionsFlights = new Subscription();

      this.subscriptionsFlights.add(
        this.enquiryFlightService
          .getAllForEnquiry(this.enquiryId)
          .subscribe((enquiryFlights: IEnquiryFlight[]) => {
            this.enquiryFlights = [...enquiryFlights];

            this.enquiryFlights.sort((a: IEnquiryFlight, b: IEnquiryFlight) => {
              if (a.departDateLocal < b.departDateLocal) {
                return -1;
              } else if (a.departDateLocal > b.departDateLocal) {
                return 1;
              } else {
                if (a.departTimeLocal < b.departTimeLocal) {
                  return -1;
                } else if (a.departTimeLocal > b.departTimeLocal) {
                  return 1;
                }
              }

              return 0;
            });

            this.loadingEnquiryFlights = false;
          })
      );
    }
  }

  loadProcessedByUser(): void {
    if (this.enquiry?.processedBy) {
      this.loadingProcessedByUser = true;

      this.subscriptions.add(
        this.userService.getFromId(this.enquiry.processedBy).subscribe((user: IUser | null) => {
          this.processedByUser = user;

          this.loadingProcessedByUser = false;
        })
      );
    }
  }

  loadEnquiryDocuments(): void {
    if (this.enquiryId) {
      this.loadingEnquiryDocuments = true;

      this.subscriptions.add(
        this.enquiryDocumentService
          .getAllForEnquiry(this.enquiryId)
          .subscribe((documents: IEnquiryDocument[]) => {
            this.enquiryDocuments = [...documents].sort(
              (a: IEnquiryDocument, b: IEnquiryDocument) => {
                if ((a.position ?? 0) < (b.position ?? 0)) {
                  return -1;
                }
                if ((a.position ?? 0) > (b.position ?? 0)) {
                  return 1;
                }
                return 0;
              }
            );
            this.loadingEnquiryDocuments = false;
          })
      );
    }
  }

  loadUsers(): void {
    this.subscriptions.add(
      this.userService.getAll().subscribe((users: IUser[]) => {
        for (const user of users) {
          this.usersObj[user.id] = user;
        }
      })
    );
  }

  async moveEnquiryDocument(index: number, direction: 'up' | 'down'): Promise<void> {
    const targetIndex = direction === 'up' ? index - 1 : index + 1;

    if (
      index < 0 ||
      targetIndex < 0 ||
      index >= this.enquiryDocuments.length ||
      targetIndex >= this.enquiryDocuments.length
    ) {
      return;
    }

    const current = this.enquiryDocuments[index];
    const target = this.enquiryDocuments[targetIndex];

    if (!current?.id || !target?.id) {
      return;
    }

    this.loaderService.presentLoader();

    try {
      await this.enquiryDocumentService.update({
        ...current,
        position: target.position
      } as IEnquiryDocument);
      await this.enquiryDocumentService.update({
        ...target,
        position: current.position
      } as IEnquiryDocument);

      await this.loaderService.hideLoaderOnSuccess();
    } catch (err: any) {
      await this.loaderService.hideLoaderOnFailure(err?.message ?? err);
    }
  }
}
